import { render, staticRenderFns } from "./notificationPanel.vue?vue&type=template&id=ab5761c6&scoped=true&"
import script from "./notificationPanel.vue?vue&type=script&lang=js&"
export * from "./notificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./notificationPanel.vue?vue&type=style&index=0&id=ab5761c6&prod&lang=less&scoped=true&"
import style1 from "./notificationPanel.vue?vue&type=style&index=1&id=ab5761c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5761c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
